import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";
import tr from "./tr";
import ar from "./ar";
import { scmLocales } from "./scmLocales";
import { uiLocales } from "./uiLocales";
import { consentLocales } from "./consentLocales";
import { stockLocales } from "./stockLocales";

const SUPPORTED_LANGS = ["en", "tr", "ar"];

function deepMerge(target, source) {
  if (!source) return target;
  const out = { ...target };
  Object.keys(source).forEach((key) => {
    const sv = source[key];
    const tv = out[key];
    if (sv && typeof sv === "object" && !Array.isArray(sv) && tv && typeof tv === "object" && !Array.isArray(tv)) {
      out[key] = deepMerge(tv, sv);
    } else {
      out[key] = sv;
    }
  });
  return out;
}

function applyDocumentDirection(lang) {
  const isRtl = lang === "ar";
  document.documentElement.dir = isRtl ? "rtl" : "ltr";
  document.documentElement.lang = lang;
  document.body?.classList.toggle("rtl", isRtl);
}

function normalizeLang(lang) {
  const base = String(lang || "en").split("-")[0].toLowerCase();
  return SUPPORTED_LANGS.includes(base) ? base : "en";
}

const savedLang = normalizeLang(localStorage.getItem("futuredoc_language") || "en");

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: [scmLocales.en, uiLocales.en, consentLocales.en, stockLocales.en].reduce(deepMerge, en) },
    tr: { translation: [scmLocales.tr, uiLocales.tr, consentLocales.tr, stockLocales.tr].reduce(deepMerge, tr) },
    ar: { translation: [scmLocales.ar, uiLocales.ar, consentLocales.ar, stockLocales.ar].reduce(deepMerge, ar) }
  },
  lng: savedLang,
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGS,
  interpolation: {
    escapeValue: false,
    prefix: "{{",
    suffix: "}}"
  }
});

applyDocumentDirection(savedLang);

export function changeLanguage(lang) {
  const next = normalizeLang(lang);
  localStorage.setItem("futuredoc_language", next);
  i18n.changeLanguage(next);
  applyDocumentDirection(next);
}

export function getCurrentLanguage() {
  return normalizeLang(i18n.language || "en");
}

export function getSupportedLanguages() {
  return SUPPORTED_LANGS;
}

export default i18n;
